<ng-container *transloco="let t">
    <h2>{{ t(reportState().titleKey) }}</h2>

    <form #form="ngForm" (submit)="submitForm(form)" novalidate>

        <dv-report-template-selector
            name="reportTemplate"
            [reportType]="reportState().asOpenapiReportType()"
            [(ngModel)]="formState().reportTemplate"/>

        <dv-kinder-orte-selection
            name="kinderOrtSelection"
            [(ngModel)]="formState().kinderOrtSelection"
            (ngModelChange)="updateState()"/>

        <div class="row form-row">
            <div class="col-xs-6">
                <dvlib-datepicker-textfield
                    name="gueltigAb"
                    [(ngModel)]="formState().gueltigAb"
                    (change)="updateState()"
                    [customOptions]="dateOptions()"
                    [required]="!defaultGueltigAb()"
                    [placeholder]="t('COMMON.GUELTIG_AB') + ': ' + ((formState().gueltigAb() || defaultGueltigAb()) | dvLocalDateFormat)"/>
            </div>
            <div class="col-xs-6">
                <dvlib-datepicker-textfield
                    name="gueltigBis"
                    [(ngModel)]="formState().gueltigBis"
                    (change)="updateState()"
                    [customOptions]="dateOptions()"
                    [required]="!defaultGueltigBis()"
                    [placeholder]="t('COMMON.GUELTIG_BIS') + ': ' + ((formState().gueltigBis() || defaultGueltigBis()) | dvLocalDateFormat)"/>
            </div>
        </div>

        <dvlib-loading-button type="submit" [isLoading]="isLoading()">
            <span>{{ t('COMMON.REPORT_GENERIEREN') }}</span>
        </dvlib-loading-button>
    </form>
</ng-container>
